var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagamentoAmpulheta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.9996,
    cy: 39.2506,
    r: 38.4,
    fill: "#0094D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2988 38.0258L45.6738 31.6508V26.0258H32.9238V31.6508L39.2988 38.0258ZM45.6738 46.0508L39.2988 39.6758L32.9238 46.0508V51.6758H45.6738V46.0508ZM29.6988 22.8758H48.8988V32.4758L42.5238 38.8508L48.8988 45.2258V54.8258H29.6988V45.2258L36.0738 38.8508L29.6988 32.4758V22.8758Z",
    fill: "#F1F2F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagamentoAmpulheta);
export default __webpack_public_path__ + "static/media/pagamentoAmpulheta.a6c59df238fd5e79cfc1ece83560c412.svg";
export { ForwardRef as ReactComponent };